import type { FormTemplate } from "../db/schema";

// While a freshly uploaded form's AI field pass runs, the server sets
// ai_processing_until. The form can't be opened, edited, or filled until then.
// The value expires by itself, so a closed tab never locks a form for good.
export function isTemplateProcessing(t: Pick<FormTemplate, "ai_processing_until">): boolean {
  const until = t.ai_processing_until;
  if (!until) return false;
  return new Date(until).getTime() > Date.now();
}

// An Auto-detect run finished and left suggestions to review. They go stale the
// moment the template is edited afterwards (updated_at moves past the run), and
// they never show while the template is still processing.
export function hasPendingSuggestions(
  t: Pick<FormTemplate, "ai_processing_until" | "ai_suggestions_at" | "updated_at">,
): boolean {
  if (!t.ai_suggestions_at || isTemplateProcessing(t)) return false;
  const ready = new Date(t.ai_suggestions_at).getTime();
  const edited = t.updated_at ? new Date(t.updated_at).getTime() : 0;
  return edited <= ready;
}
